// import { handleActions } from 'redux-actions';
import * as Bank from '../../constants/User/Bank';

const initialState = {
  usersCards: null,
  userAccount: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Bank.BANK_REGIST:
      return state;
    case Bank.BANK_DELETE:
      return state;
    case Bank.BANK_DELETE_RESULT:
      return state;
    case Bank.BANK_INFO_GET_RESULT:
      return Object.assign({}, state, {
        userAccount: action.account
      });
    case Bank.BANK_INFO_GET_RESET:
      return Object.assign({}, state, {
        userAccount: null
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/Bank.js